import msg from "components/string-table";
import { Section } from "main";

type EditableAboutMe =
  | {
      isEditable: false;
    }
  | {
      isEditable: true;
      onEditAboutMe: () => void;
    };

export type AboutMeProps = {
  about?: string;
  editable?: EditableAboutMe;
};

export function AboutMe(props: AboutMeProps) {
  const { about, editable } = props;

  return (
    <Section
      title={msg("SUB_PROFILE_ABOUT_HEADER")}
      onEditClick={editable?.isEditable ? editable.onEditAboutMe : undefined}
    >
      <div>
        <p style={{ marginBottom: 0, lineHeight: "var(--swing-line-height-normal)" }}>
          {about ? (
            <span>{about}</span>
          ) : (
            <span style={{ fontStyle: "italic" }}>
              {editable?.isEditable
                ? `${msg("SUB_PROFILE_ABOUT_EDIT_EMPTY")}.`
                : msg("SUB_PROFILE_NO_INFORMATION")}
            </span>
          )}
        </p>
      </div>
    </Section>
  );
}
